import { Popconfirm, Space, Table, Tag, Input } from "antd";
import moment from "moment";
import React, { useContext, useState } from "react";
import { UserContext } from "../../../context";
import { SITUACOES } from "../../../models/solicitacoes";
import history from "../../../routes/history";
import { abrirComprovanteSolicitacao } from "../../../services/solicitacoes";
import { abrirComprovanteViagem } from "../../../services/viagens";

const situacoesStyle = {
  LANÇADO: "yellow",
  CANCELADO: "red",
  FINALIZADO: "green",
};

const prioridadeStyle = {
  ELETIVO: "#73d13d",
  PRIORITARIO: "#fadb14",
  URGENCIA: "#cf1322",
};
const { TextArea } = Input;
const { Column } = Table;
export default function ViagensTable({
  viagens,
  loading,
  handleTableChange,
  total,
  confirm,
  finalizar,
  cancelar,
}) {
  const [observacao, setObservacao] = useState();
  function cancel(e) {
    console.log(e);
  }

  const onChangeObservacao = (text) => {
    setObservacao(text.target.value);
  };

  const formatDateTime = (date, format) => {
    if (!date) return null;
    console.log(date);
    try {
      return moment(date).format(format);
    } catch {
      return date; // Retorna original se der erro
    }
  };
  const user = useContext(UserContext);
  return (
    <div>
      <Table
        loading={loading}
        size="small"
        pagination={{ pageSize: 10, total }}
        onChange={handleTableChange}
        style={{ width: "100%" }}
        dataSource={viagens}
        rowKey="id"
      >
        <Column title="Código" dataIndex="id" key="id" />
        <Column
          title="Status"
          dataIndex="status"
          key="status"
          render={(status) => (
            <Tag color={situacoesStyle[status]} key={status}>
              {status}
            </Tag>
          )}
        />
        <Column
          title="Paciente"
          dataIndex={["paciente", "pessoa_fisica", "nome"]}
          key="paciente_nome"
        />
        <Column
          title="Motorista"
          dataIndex={["motorista", "nome"]}
          key="motorista_nome"
        />
        <Column
          title="Veiculo"
          dataIndex={["veiculo", "descricao"]}
          key="veiculo_desc"
        />
        <Column
          title="Data de Saida"
          dataIndex={"data_saida"}
          render={(data) => formatDateTime(data, "DD/MM/YYYY")}
          key="data_saida"
        />
        <Column
          title="Horario de saida"
          dataIndex={"horario_saida"}
          key="horario_saida"
        />
        <Column
          title="Origem"
          dataIndex={["local_origem", "descricao"]}
          key="origem"
        />
        <Column
          title="Destino"
          dataIndex={["local_destino", "descricao"]}
          key="destino"
        />
        <Column
          title="Prioridade"
          dataIndex="prioridade"
          key="prioridade"
          render={(prioridade) => (
            <Tag color={prioridadeStyle[prioridade]} key={prioridade}>
              {prioridade}
            </Tag>
          )}
        />
        <Column
          title="Ação"
          key="action"
          render={(text, record) => (
            <>
                <>
                  <Space size="middle">
                    <a onClick={() => history.push(`/viagens/${record.id}`)}>
                      Visualizar
                    </a>

                    {record.status !== SITUACOES.CANCELADO && (
                        <a onClick={() => abrirComprovanteViagem(record.id)}>
                          Comprovante
                        </a>
                      )}
                    {user?.type === "ADM" && record.status !== SITUACOES.FINALIZADO && record.status !== SITUACOES.CANCELADO && (
                      <Popconfirm
                        title="Deseja deletar a viagem?"
                        onConfirm={() => confirm(record)}
                        onCancel={cancel}
                        okText="Sim"
                        cancelText="Não"
                      >
                        <a>Deletar</a>
                      </Popconfirm>
                    )}
                    {user?.type === "ADM" &&
                      record.status !== SITUACOES.FINALIZADO && record.status !== SITUACOES.CANCELADO && (
                        <Popconfirm
                          title={
                            <div>
                              <div>
                                Deseja confirmar o <b>cancelamento</b>? Digite
                                a observação:
                              </div>
                              <TextArea
                                onChange={onChangeObservacao}
                                rows={4}
                              />
                            </div>
                          }
                          onConfirm={() => cancelar(record, observacao)}
                          onCancel={cancel}
                          okButtonProps={{ disabled: !observacao }}
                          okText="Sim"
                          cancelText="Não"
                        >
                          <a>Cancelar</a>
                        </Popconfirm>
                      )}
                  </Space>
                </>
            </>
          )}
        />
      </Table>
    </div>
  );
}
